var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateUploadResumeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10686_25706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1642 6.15549L7.22631 11.0934C6.92409 11.3956 6.7543 11.8055 6.7543 12.2329C6.7543 12.6603 6.92409 13.0702 7.22631 13.3725C7.52853 13.6747 7.93843 13.8445 8.36583 13.8445C8.79324 13.8445 9.20313 13.6747 9.50535 13.3725L14.4433 8.43453C15.0477 7.83009 15.3873 7.0103 15.3873 6.15549C15.3873 5.30068 15.0477 4.48089 14.4433 3.87645C13.8388 3.27201 13.019 2.93243 12.1642 2.93243C11.3094 2.93243 10.4896 3.27201 9.8852 3.87645L4.94727 8.81437C4.04061 9.72103 3.53125 10.9507 3.53125 12.2329C3.53125 13.5152 4.04061 14.7448 4.94727 15.6515C5.85393 16.5582 7.08362 17.0675 8.36583 17.0675C9.64804 17.0675 10.8777 16.5582 11.7844 15.6515L16.7223 10.7136",
    stroke: "#2064ED",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10686_25706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.6919,
    rx: 3.87973,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateUploadResumeIcon);
export default __webpack_public_path__ + "static/media/candidate-upload-resume-icon.cb65acac28584c9c5e4b0f9b4982b453.svg";
export { ForwardRef as ReactComponent };